export default __webpack_public_path__ + "static/media/gallery-grid-img-3.c2a5f68d.jpg";